import type { AnyValue } from '@mntn-dev/utility-types'

// Levenshtein distance function to calculate similarity
export function levenshtein(a: string, b: string): number {
  // Define the matrix with fixed lengths and explicitly type it
  const matrix = Array.from(
    { length: a.length + 1 },
    () => new Array(b.length + 1).fill(0) as number[]
  ) as AnyValue[]

  // Initialize the first row and column of the matrix
  for (let i = 0; i <= a.length; i++) {
    matrix[i][0] = i
  }
  for (let j = 0; j <= b.length; j++) {
    matrix[0][j] = j
  }

  // Compute the edit distances
  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1
      matrix[i][j] = Math.min(
        matrix[i - 1][j] + 1, // deletion
        matrix[i][j - 1] + 1, // insertion
        matrix[i - 1][j - 1] + cost // substitution
      )
    }
  }

  return matrix[a.length][b.length]
}
